(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avonlea-scrap-gold-calculator"] && !Shopify.designMode) return;
  try {
    
function initAvonleaGoldCalculator(root) {
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const $ = (selector) => root.querySelector(selector);
  const TROY_OUNCE_GRAMS = 31.1034768;
  const CACHE_KEY = 'avonlea_gold_spot_usd_v3';
  const CACHE_MAX_AGE_MS = 5 * 60 * 1000;
  const LIVE_MAX_AGE_MS = 15 * 60 * 1000;
  const recoverablePercent = Math.min(100, Math.max(0, Number(root.dataset.recoverablePercent) || 92));
  const recoverableMultiplier = recoverablePercent / 100;
  const fallbackSpot = Number(root.dataset.fallbackSpot) || 0;
  const contactEmail = (root.dataset.contactEmail || 'support@avonleajewelry.com').trim();
  const contactPhoneDisplay = (root.dataset.contactPhone || '409-227-0418').trim();
  const contactPhoneDigits = contactPhoneDisplay.replace(/\D/g, '');
  const contactPhoneE164 = contactPhoneDigits.length === 10 ? `+1${contactPhoneDigits}` : `+${contactPhoneDigits}`;
  const photoEndpoint = (root.dataset.photoEndpoint || '').trim();

  const form = $('[data-calculator-form]');
  const weightInput = $('[data-weight]');
  const unitInput = $('[data-unit]');
  const karatInput = $('[data-karat]');
  const deductionInput = $('[data-deduction]');
  const calculateButton = $('[data-calculate]');
  const formError = $('[data-form-error]');
  const spotCard = $('[data-spot-card]');
  const spotPrice = $('[data-spot-price]');
  const spotMeta = $('[data-spot-meta]');
  const refreshButton = $('[data-refresh-price]');
  const resultEmpty = $('[data-result-empty]');
  const results = $('[data-results]');
  const meltValue = $('[data-melt-value]');
  const netWeightOutput = $('[data-net-weight]');
  const fineWeightOutput = $('[data-fine-weight]');
  const gramPriceOutput = $('[data-gram-price]');
  const purityLabelOutput = $('[data-purity-label]');
  const openContactButton = $('[data-open-contact-modal]');
  const contactModal = $('[data-contact-modal]');
  const contactDialog = $('[data-contact-dialog]');
  const closeContactButtons = Array.from(root.querySelectorAll('[data-close-contact-modal]'));
  const emailContactButton = $('[data-email-contact]');
  const textContactButton = $('[data-text-contact]');

  const photoInput = $('[data-photo-input]');
  const photoPreview = $('[data-photo-preview]');
  const photoImage = $('[data-photo-image]');
  const photoName = $('[data-photo-name]');
  const removePhotoButton = $('[data-remove-photo]');
  const photoError = $('[data-photo-error]');
  const photoPrivacy = $('[data-photo-privacy]');
  const photoSubmitArea = $('[data-photo-submit-area]');
  const submitPhotoButton = $('[data-submit-photo]');
  const customerNameInput = $('[data-customer-name]');
  const customerEmailInput = $('[data-customer-email]');
  const photoStatus = $('[data-photo-status]');

  const requiredElements = [
    form,
    weightInput,
    unitInput,
    karatInput,
    deductionInput,
    calculateButton,
    formError,
    spotCard,
    spotPrice,
    spotMeta,
    refreshButton,
    resultEmpty,
    results,
    meltValue,
    netWeightOutput,
    fineWeightOutput,
    gramPriceOutput,
    purityLabelOutput,
    openContactButton,
    contactModal,
    contactDialog,
    emailContactButton,
    textContactButton
  ];

  if (requiredElements.some((element) => !element)) {
    console.error('Avonlea gold calculator could not initialize because required markup is missing.', root);
    delete root.dataset.initialized;
    return;
  }

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const state = {
    spot: null,
    spotAsOf: null,
    spotState: 'loading',
    spotSource: null,
    lastEstimate: null,
    modalLastFocus: null,
    previousBodyOverflow: '',
    photoFile: null,
    photoUrl: null
  };

  function formatCurrency(value) {
    return currencyFormatter.format(Number(value) || 0);
  }

  function formatNumber(value, digits = 2) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(Number(value) || 0);
  }

  function unitToGrams(unit) {
    const factors = {
      g: 1,
      dwt: 1.55517384,
      ozt: TROY_OUNCE_GRAMS,
      oz: 28.349523125
    };
    return factors[unit] || 1;
  }

  function setMessage(element, message) {
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
  }

  function readCachedSpot() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (!cached || !Number.isFinite(Number(cached.price))) return null;
      if (Date.now() - Number(cached.savedAt) > CACHE_MAX_AGE_MS) return null;
      return cached;
    } catch (error) {
      return null;
    }
  }

  function writeCachedSpot(payload) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ...payload, savedAt: Date.now() }));
    } catch (error) {
      // The calculator still works when browser storage is unavailable.
    }
  }

  function relativeTime(isoDate) {
    const timestamp = Date.parse(isoDate);
    if (!Number.isFinite(timestamp)) return 'just now';
    const seconds = Math.max(0, Math.round((Date.now() - timestamp) / 1000));
    if (seconds < 60) return `${seconds} sec ago`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.round(minutes / 60);
    return `${hours} hr ago`;
  }

  function applySpot(payload, origin = 'live') {
    const price = Number(payload.price);
    if (!Number.isFinite(price) || price < 100 || price > 100000) {
      throw new Error('The market feed returned an invalid gold price.');
    }

    const asOf = payload.asOf || new Date().toISOString();
    const ageMs = Date.now() - Date.parse(asOf);
    const tooOld = Number.isFinite(ageMs) && ageMs > LIVE_MAX_AGE_MS;
    const stale = payload.status === 'stale' || payload.status === 'unavailable' || tooOld;

    state.spot = price;
    state.spotAsOf = asOf;
    state.spotState = stale ? 'stale' : 'fresh';
    state.spotSource = payload.source || 'market feed';

    spotCard.dataset.state = stale ? 'stale' : 'fresh';
    spotPrice.textContent = `${formatCurrency(price)} / troy oz`;

    if (origin === 'fallback') {
      spotMeta.textContent = 'Using the store’s manual backup price';
    } else if (origin === 'cache') {
      spotMeta.textContent = `Recently cached ${state.spotSource} price · ${relativeTime(asOf)}`;
    } else if (stale) {
      spotMeta.textContent = `Last known ${state.spotSource} price · ${relativeTime(asOf)}`;
    } else {
      spotMeta.textContent = `Live via ${state.spotSource} · updated ${relativeTime(asOf)}`;
    }

    calculateButton.disabled = false;

    if (state.lastEstimate) {
      calculateEstimate(false);
    }
  }

  async function fetchJson(url, timeoutMs = 8000) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || `Market feed error (${response.status})`);
      }
      return data;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  async function fetchGoldApiPrice() {
    const data = await fetchJson('https://api.gold-api.com/price/XAU');
    return {
      price: Number(data.price),
      asOf: data.updatedAt || new Date().toISOString(),
      status: 'fresh',
      source: 'Gold API'
    };
  }

  async function fetchXausPrice() {
    const cacheBuster = Math.floor(Date.now() / 60000);
    const data = await fetchJson(`https://xaus.com/api/v1/spot?compact=1&avonlea=${cacheBuster}`);
    return {
      price: Number(data.spot_usd_oz ?? data.xau?.price),
      asOf: data.price_as_of || data.data_state?.as_of || data.updated_at || new Date().toISOString(),
      status: data.data_state?.status || (data.stale ? 'stale' : 'fresh'),
      source: 'XAUS'
    };
  }

  async function fetchLiveSpot(force = false) {
    const cached = !force ? readCachedSpot() : null;
    if (cached) {
      try {
        applySpot(cached, 'cache');
      } catch (error) {
        // Ignore a malformed cached value and continue to the network.
      }
    } else if (!state.spot) {
      spotCard.dataset.state = 'loading';
      spotPrice.textContent = 'Loading market price...';
      spotMeta.textContent = 'Connecting to the live feed';
      calculateButton.disabled = true;
    }

    refreshButton.disabled = true;
    let lastError = null;
    let newestStalePayload = null;

    for (const fetchFeed of [fetchGoldApiPrice, fetchXausPrice]) {
      try {
        const payload = await fetchFeed();
        const timestamp = Date.parse(payload.asOf || '');
        const ageMs = Number.isFinite(timestamp) ? Date.now() - timestamp : 0;
        const isStale = payload.status === 'stale' || payload.status === 'unavailable' || ageMs > LIVE_MAX_AGE_MS;

        if (!isStale) {
          applySpot(payload, 'live');
          writeCachedSpot(payload);
          refreshButton.disabled = false;
          return;
        }

        const previousTimestamp = Date.parse(newestStalePayload?.asOf || '');
        if (!newestStalePayload || !Number.isFinite(previousTimestamp) || timestamp > previousTimestamp) {
          newestStalePayload = { ...payload, status: 'stale' };
        }
      } catch (error) {
        lastError = error;
      }
    }

    if (newestStalePayload) {
      applySpot(newestStalePayload, 'live');
      writeCachedSpot(newestStalePayload);
    } else if (!state.spot && fallbackSpot > 0) {
      applySpot({
        price: fallbackSpot,
        asOf: new Date().toISOString(),
        status: 'stale',
        source: 'manual backup'
      }, 'fallback');
    } else if (!state.spot) {
      spotCard.dataset.state = 'error';
      spotPrice.textContent = 'Live price unavailable';
      spotMeta.textContent = 'Refresh the feed before calculating';
      calculateButton.disabled = true;
    } else {
      spotMeta.textContent = 'Live refresh failed; using the most recent price shown';
    }

    if (lastError) console.warn('Gold price feeds unavailable:', lastError);
    refreshButton.disabled = false;
  }

  function buildContactLinks() {
    const estimate = state.lastEstimate;
    const subject = 'Free gold evaluation appointment';
    const details = estimate
      ? [
          '',
          `Estimated recoverable value: ${formatCurrency(estimate.estimatedMeltValue)}`,
          `Net metal weight: ${formatNumber(estimate.netWeightGrams, 2)} g`,
          `Fine gold content: ${formatNumber(estimate.fineGoldGrams, 2)} g`,
          `Selected purity: ${estimate.purityLabel}`
        ]
      : [];

    const emailBody = [
      'Hello Avonlea Jewelers,',
      '',
      'I would like to schedule a free appointment to evaluate my gold.',
      ...details,
      '',
      `Calculator page: ${window.location.href}`
    ].join('\n');

    emailContactButton.href = `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;

    const textBody = estimate
      ? `Hello Avonlea Jewelers, I would like to schedule a free gold evaluation. My calculator estimate is ${formatCurrency(estimate.estimatedMeltValue)} for ${estimate.purityLabel}.`
      : 'Hello Avonlea Jewelers, I would like to schedule a free appointment to evaluate my gold.';

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const smsSeparator = isIOS ? '&' : '?';
    textContactButton.href = `sms:${contactPhoneE164}${smsSeparator}body=${encodeURIComponent(textBody)}`;
  }

  function openContactModal() {
    buildContactLinks();
    state.modalLastFocus = document.activeElement;
    state.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    contactModal.hidden = false;
    window.requestAnimationFrame(() => contactDialog.focus());
  }

  function closeContactModal() {
    if (contactModal.hidden) return;
    contactModal.hidden = true;
    document.body.style.overflow = state.previousBodyOverflow;
    state.modalLastFocus?.focus?.();
  }

  function invalidateEstimate() {
    if (!state.lastEstimate) return;
    state.lastEstimate = null;
    results.hidden = true;
    resultEmpty.hidden = false;
  }

  function calculateEstimate(showValidation = true) {
    setMessage(formError, '');

    const weight = Number(weightInput.value);
    const deduction = Number(deductionInput.value || 0);
    const purity = Number(karatInput.value);
    const unit = unitInput.value;

    let errorMessage = '';
    if (!state.spot) {
      errorMessage = 'The live gold price must load before this estimate can be calculated.';
    } else if (!Number.isFinite(weight) || weight <= 0) {
      errorMessage = 'Enter an item weight greater than zero.';
    } else if (!Number.isFinite(deduction) || deduction < 0) {
      errorMessage = 'Stone/non-gold weight cannot be negative.';
    } else if (deduction >= weight) {
      errorMessage = 'Stone/non-gold weight must be less than the total item weight.';
    } else if (!Number.isFinite(purity) || purity <= 0 || purity > 1) {
      errorMessage = 'Choose the item’s gold purity.';
    }

    if (errorMessage) {
      if (showValidation) setMessage(formError, errorMessage);
      return false;
    }

    const gramsPerUnit = unitToGrams(unit);
    const netWeightGrams = (weight - deduction) * gramsPerUnit;
    const fineGoldGrams = netWeightGrams * purity;
    const pureGoldPricePerGram = state.spot / TROY_OUNCE_GRAMS;
    const theoreticalMeltValue = fineGoldGrams * pureGoldPricePerGram;
    const estimatedMeltValue = theoreticalMeltValue * recoverableMultiplier;
    const purityLabel = karatInput.options[karatInput.selectedIndex]?.text || `${formatNumber(purity * 100, 1)}%`;

    state.lastEstimate = {
      weight,
      unit,
      deduction,
      purity,
      purityLabel,
      netWeightGrams,
      fineGoldGrams,
      pureGoldPricePerGram,
      theoreticalMeltValue,
      estimatedMeltValue,
      spot: state.spot,
      spotAsOf: state.spotAsOf,
      recoverablePercent
    };

    meltValue.textContent = formatCurrency(estimatedMeltValue);
    netWeightOutput.textContent = `${formatNumber(netWeightGrams, 2)} g`;
    fineWeightOutput.textContent = `${formatNumber(fineGoldGrams, 2)} g`;
    gramPriceOutput.textContent = formatCurrency(pureGoldPricePerGram);
    purityLabelOutput.textContent = purityLabel;

    resultEmpty.hidden = true;
    results.hidden = false;
    return true;
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (calculateEstimate(true)) {
      results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  [weightInput, unitInput, karatInput, deductionInput].forEach((element) => {
    element.addEventListener('input', invalidateEstimate);
    element.addEventListener('change', invalidateEstimate);
  });

  openContactButton.addEventListener('click', () => {
    if (!state.lastEstimate && !calculateEstimate(true)) return;
    openContactModal();
  });

  closeContactButtons.forEach((button) => {
    button.addEventListener('click', closeContactModal);
  });

  contactDialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeContactModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      contactDialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter((element) => !element.hidden && element.offsetParent !== null);

    if (!focusable.length) {
      event.preventDefault();
      contactDialog.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  refreshButton.addEventListener('click', () => fetchLiveSpot(true));

  function clearPhoto() {
    state.photoFile = null;
    if (state.photoUrl) URL.revokeObjectURL(state.photoUrl);
    state.photoUrl = null;
    if (photoInput) photoInput.value = '';
    if (photoImage) photoImage.removeAttribute('src');
    if (photoPreview) photoPreview.hidden = true;
    setMessage(photoError, '');
  }

  if (photoInput) {
    if (photoEndpoint && photoSubmitArea) {
      photoSubmitArea.hidden = false;
      if (photoPrivacy) photoPrivacy.textContent = 'Your photo is uploaded only after you choose “Send photo for a human review.”';
    }

    photoInput.addEventListener('change', () => {
      setMessage(photoError, '');
      const file = photoInput.files?.[0];
      if (!file) {
        clearPhoto();
        return;
      }

      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        clearPhoto();
        setMessage(photoError, 'Choose a JPG, PNG, or WebP image.');
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        clearPhoto();
        setMessage(photoError, 'The photo must be smaller than 10 MB.');
        return;
      }

      if (state.photoUrl) URL.revokeObjectURL(state.photoUrl);
      state.photoFile = file;
      state.photoUrl = URL.createObjectURL(file);
      photoImage.src = state.photoUrl;
      photoName.textContent = file.name;
      photoPreview.hidden = false;
    });
  }

  removePhotoButton?.addEventListener('click', clearPhoto);

  submitPhotoButton?.addEventListener('click', async () => {
    setMessage(photoError, '');
    setMessage(photoStatus, '');

    if (!photoEndpoint) return;
    if (!state.photoFile) {
      setMessage(photoError, 'Take or choose a photo before sending it.');
      return;
    }
    if (!state.lastEstimate && !calculateEstimate(true)) {
      setMessage(photoError, 'Complete the calculator before sending a photo.');
      return;
    }

    const email = customerEmailInput?.value.trim() || '';
    const name = customerNameInput?.value.trim() || '';
    if (!name) {
      setMessage(photoError, 'Enter your name for the photo review.');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setMessage(photoError, 'Enter a valid email address for the photo review.');
      return;
    }

    const formData = new FormData();
    formData.append('photo', state.photoFile, state.photoFile.name);
    formData.append('customer_name', name);
    formData.append('customer_email', email);
    formData.append('item_weight', String(state.lastEstimate.weight));
    formData.append('weight_unit', state.lastEstimate.unit);
    formData.append('non_gold_weight', String(state.lastEstimate.deduction));
    formData.append('purity', state.lastEstimate.purityLabel);
    formData.append('spot_usd_per_troy_oz', String(state.lastEstimate.spot));
    formData.append('theoretical_melt_value', state.lastEstimate.theoreticalMeltValue.toFixed(2));
    formData.append('estimated_recoverable_value', state.lastEstimate.estimatedMeltValue.toFixed(2));
    formData.append('recoverable_percent', String(state.lastEstimate.recoverablePercent));
    formData.append('page_url', window.location.href);

    submitPhotoButton.disabled = true;
    setMessage(photoStatus, 'Sending your photo...');

    try {
      const response = await fetch(photoEndpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: photoEndpoint.startsWith('/') ? 'same-origin' : 'omit'
      });
      const responseBody = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(responseBody.error || 'The photo could not be sent.');
      setMessage(photoStatus, responseBody.message || 'Your photo was sent for review.');
    } catch (error) {
      setMessage(photoStatus, 'The photo could not be sent. Please use the contact page instead.');
    } finally {
      submitPhotoButton.disabled = false;
    }
  });

  fetchLiveSpot(false);

  const refreshInterval = window.setInterval(() => {
    if (!root.isConnected) {
      window.clearInterval(refreshInterval);
      return;
    }
    if (document.visibilityState === 'visible') fetchLiveSpot(true);
  }, 5 * 60 * 1000);

  const handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible') return;
    const asOf = Date.parse(state.spotAsOf || '');
    if (!Number.isFinite(asOf) || Date.now() - asOf > 5 * 60 * 1000) fetchLiveSpot(true);
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  root.avonleaGoldCalculatorCleanup = () => {
    window.clearInterval(refreshInterval);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    if (!contactModal.hidden) document.body.style.overflow = state.previousBodyOverflow;
    if (state.photoUrl) URL.revokeObjectURL(state.photoUrl);
    delete root.avonleaGoldCalculatorCleanup;
    delete root.dataset.initialized;
  };
}

function initAvonleaGoldCalculators(scope = document) {
  const roots = [];

  if (scope?.matches?.('[data-avonlea-gold-calculator]')) {
    roots.push(scope);
  }

  scope?.querySelectorAll?.('[data-avonlea-gold-calculator]').forEach((root) => {
    if (!roots.includes(root)) roots.push(root);
  });

  roots.forEach(initAvonleaGoldCalculator);
}

function bootAvonleaGoldCalculators() {
  initAvonleaGoldCalculators(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootAvonleaGoldCalculators, { once: true });
} else {
  bootAvonleaGoldCalculators();
}

document.addEventListener('shopify:section:load', (event) => {
  initAvonleaGoldCalculators(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const root = event.target?.matches?.('[data-avonlea-gold-calculator]')
    ? event.target
    : event.target?.querySelector?.('[data-avonlea-gold-calculator]');

  root?.avonleaGoldCalculatorCleanup?.();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
